import React, { Component } from 'react'
import { Field } from 'redux-form'
import SelectPretty from 'components/Input/SelectPretty'

import { vRequired } from 'components/Input/Input.validations'

export default class BillingAccountField extends Component {
  componentWillMount() {
    const { getBillingAccounts } = this.props
    getBillingAccounts()
  }
  showBillingCreateFormModal = () => {
    const { showBillingCreateFormModal, change } = this.props
    showBillingCreateFormModal().then(
      ({
        value: {
          value: { data },
        },
      }) => {
        change('ban', data.ban)
      }
    )
  }
  render() {
    const { billingAccounts, hideCreate } = this.props
    const options = billingAccounts.map(item => ({
      value: item.ban,
      name: `${item.customer} - (${item.ban})`,
    }))

    return (
      <div>
        {options.length > 0 && (
          <Field
            label="Billing Account"
            component={SelectPretty}
            options={options}
            name="ban"
            validate={[vRequired]}
          />
        )}
        {!hideCreate && (
          <a
            style={{ color: 'inherit', textDecoration: 'underline' }}
            onClick={this.showBillingCreateFormModal}
          >
            Create New Billing Account
          </a>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountField/BillingAccountField.jsx